import { FC } from "react";
import { SortOrder } from "../../../../store/vacancy/types";
import Sort from "../../../UI/Icons/Sort";
import { TSortByFields } from "../../../../store/timesheet/types";

export type sortFields =
  | "business_name"
  | "current_jobs_count"
  | "past_jobs_count"
  | "last_job_date";

interface ListHeaderProps {
  /** Assuming it's a string like "first_name" */
  selectedSortBy: string;
  /** If sort order is always "asc" or "desc" */
  selectedSortOrder: SortOrder;
  /** Function type with a string parameter */
  handleSortChange: (sortBy: TSortByFields) => void;
}

const ListHeader: FC<ListHeaderProps> = ({
  selectedSortBy,
  selectedSortOrder,
  handleSortChange,
}) => {
  return (
    <>
      <div className="d-none d-lg-flex gap-20 py-10px px-15px border-top border-bottom border-off-white fs-13 fw-700 text-black">
        <div className="min-w-50px"></div>
        <div className="flex-grow-1 d-flex gap-5 align-items-center">
          Centre
          <div onClick={() => handleSortChange("centre")}>
            <Sort
              active={selectedSortBy === "centre"}
              direction={selectedSortOrder}
            />
          </div>
        </div>
        <div className="min-w-250px d-flex gap-5 align-items-center">
          Job Timeframe
          <div onClick={() => handleSortChange("time_frame")}>
            <Sort
              active={selectedSortBy === "time_frame"}
              direction={selectedSortOrder}
            />
          </div>
        </div>
        <div className="min-w-380px"></div>
      </div>
    </>
  );
};

export default ListHeader;
